// extracted by mini-css-extract-plugin
export default {"root":"IconMarker_root__vsae0"};